import { AIAssessmentResponseType, serverAssessSubmission } from "./assessment-query";

import { SubmissionType } from "components/server-types";

/**
 * A map of submission IDs to their (eventual) AI assessment result.
 */
const AiAssessmentCache = new Map<string, Promise<AIAssessmentResponseType>>();

/**
 * This runs an AI assessment for a submission, or returns a cached promise if one already exists
 * or is already running.
 *
 * skipCache will force a new promise to be returned that only resolved once the new AI run completes.
 */
export const getOrRunAiAssessment = (
  submission: Pick<SubmissionType, "id" | "page_id">,
  skipCache: boolean = false,
) => {
  const cachedPromise = AiAssessmentCache.get(submission.id);
  if (cachedPromise && !skipCache) {
    return cachedPromise;
  }

  const promise = serverAssessSubmission(submission);
  AiAssessmentCache.set(submission.id, promise);
  return promise;
};

export const hasAiAssessment = (submissionId: string) => {
  return AiAssessmentCache.has(submissionId);
};

export const clearAiAssessment = (submissionId: string) => {
  AiAssessmentCache.delete(submissionId);
};
